module.exports = __webpack_public_path__ + "static/media/img006.f2f4ef6a.jpg";